// Configuration for "Sign in with Apple" on the web. A single Services ID
// registered on team Y26UM4LFS5 (Tuyou Computing Shanghai) covers both
// capcam.app and capcam.cn — Apple Services IDs accept multiple associated
// domains, so one identifier is enough as long as both domains and both
// return URLs are listed on it in the Apple Developer console.
//
// Production hostnames are hardcoded constants because they're public
// identifiers, not secrets, and a single source of truth in the repo is
// easier to audit than scattered env vars.
//
// Local development uses REACT_APP_APPLE_DEV_SERVICES_ID so each developer
// can register their own ngrok tunnel domain in the Apple Developer console
// and put the resulting Services ID in their own local .env. Apple does not
// accept localhost — see README "Sign in with Apple — local dev".

export const APPLE_SDK_URL =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

export const APPLE_SCOPE = "name email";

// Production Services IDs registered in the Apple Developer console.
const PROD_SERVICES_IDS: Record<string, string> = {
  "capcam.app": "com.tuyoucomputing.auth.web",
  "www.capcam.app": "com.tuyoucomputing.auth.web",
  "capcam.cn": "com.tuyoucomputing.auth.web",
  "www.capcam.cn": "com.tuyoucomputing.auth.web",
};

const getHostname = (): string => {
  if (typeof window === "undefined") return "";
  return window.location.hostname;
};

export const getAppleClientId = (): string => {
  const hostname = getHostname();
  if (hostname && PROD_SERVICES_IDS[hostname]) {
    return PROD_SERVICES_IDS[hostname];
  }
  // Dev / tunnel fallback. Empty string means "not configured" — appleAuth
  // throws a clear error so misconfig fails loudly instead of crashing
  // inside Apple's SDK.
  return process.env.REACT_APP_APPLE_DEV_SERVICES_ID || "";
};

export const getAppleRedirectUri = (): string => {
  if (typeof window === "undefined") return "";
  // With usePopup: true Apple never actually navigates here — the URL just
  // has to be on the Services ID's allow-list in the Apple console. We do
  // not need a React Router route at /auth/apple/callback.
  return `${window.location.origin}/auth/apple/callback`;
};
